import { memo } from 'react';
import { useSnapshot } from 'valtio';

import Text from '@cartwhl/ui/base/TextNew';
import Overlay from '@cartwhl/ui/player/Overlay';

import { userStore } from 'stores/global';

import { AdvancedIcon } from '../components/icons';
import { canUseMotionEditorRepathing } from '../feature-flags';
import { KeyPoseControlsOptions } from '../keyPoses';
import RepathingControlsOptions from './RepathingControlsPanel';
import { useStore } from './repathingStore';

function EditControlsOverlay() {
  const store = useStore();
  const { isCartwheeler } = useSnapshot(userStore.state);
  const { controlsMode, generation } = store.state;
  const canUseRepathing = canUseMotionEditorRepathing(isCartwheeler);
  const visibleControlsMode = canUseRepathing ? controlsMode : 'body';

  return (
    <Overlay.Panel
      placement="top-left"
      tooltipSide="top"
      widthClassName="w-[190px]"
      collapsible
    >
      <Overlay.PanelHeader icon={<AdvancedIcon />} title="Edit controls" />
      <Overlay.Content>
        {canUseRepathing ? (
          <>
            <Overlay.Group orientation="vertical">
              <Text token="12/medium" className="text-primary mb-1">
                Edit:
              </Text>
              <Overlay.Group orientation="horizontal">
                <Overlay.Button
                  active={controlsMode === 'body'}
                  disabled={generation.status === 'pending'}
                  text="Body"
                  tooltipText="Edit body key poses"
                  onClick={() => store.setControlsMode('body')}
                />
                <Overlay.Button
                  active={controlsMode === 'path'}
                  disabled={generation.status === 'pending'}
                  text="Path"
                  tooltipText="Edit root path"
                  onClick={() => store.setControlsMode('path')}
                />
              </Overlay.Group>
            </Overlay.Group>
            <Overlay.Divider />
          </>
        ) : null}
        {visibleControlsMode === 'body' ? (
          <KeyPoseControlsOptions />
        ) : (
          <RepathingControlsOptions />
        )}
      </Overlay.Content>
    </Overlay.Panel>
  );
}

const MemoizedEditControlsOverlay = Object.assign(memo(EditControlsOverlay), {
  overlayPlacement: 'top-left',
});

export default MemoizedEditControlsOverlay;
